import { useEffect, useState } from "react";
import { includes } from "ramda";
import { useSelector } from "react-redux";
import { getProjectId } from "./selectors";
import { notBlank } from "./general";
// [Tyler] We currently manually change certain features for Qatar National Library projects
const QNL_PROJECTS = [
  "ea1c952d-5066-4285-b875-252498af4ca7", // Write to Inspire (Arabic)
  "11e5115a-f512-402f-99f8-905a27f64f2f", // Keys to Palestine (Arabic)
  "672605fa-5511-45d0-8cf9-495943b7a74e", // Keys to Palestine (English)
  "66110a0f-1b5b-4fae-a258-b79490763682", // Write to Inspire (English)
];

export const useIsQatarProject = () => {
  const projectId = useSelector(getProjectId);
  const [isQatarProject, setIsQatarProject] = useState(false);

  useEffect(() => {
    if (notBlank(projectId)) {
      setIsQatarProject(includes(projectId, QNL_PROJECTS));
    }
  }, [projectId]);

  return isQatarProject;
};
